import { render } from "./InstitutionFamily.vue?vue&type=template&id=8fe23bec"
import script from "./InstitutionFamily.vue?vue&type=script&lang=js"
export * from "./InstitutionFamily.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__